import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.module.scss';
import { Image, Row, Col} from 'react-bootstrap';
// import { browserHistory } from 'react-router';
import GoogleAnalyticsIcon from 'src/legacy/images/google_analytics.svg';
import GoogleAnalyticsActivationPage from './GoogleAnalyticsActivationPage';
import DeactivateIntegrationContainer from "src/legacy/components/DeactivateIntegration/index";
import BackButton from 'src/legacy/components/BackButton';
import { shouldFetchIntegrations } from 'src/legacy/services/utils';
import { localizedStrings } from 'src/localization/index.jsx';

class GoogleAnalyticsView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);
    this.state={
      deleteConfirmation: false
    }
    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedGoogleAnalytics = localizedStrings.components.integrations.google_analytics;
  }

  _handleDeactivateClicked(){
    this.setState({
      deleteConfirmation: true
    })
  }

  componentDidMount(){

    if(shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }

  }
  
  render(){
    return (
      <div className={styles.content}>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            <BackButton className={styles.back} title={this.localizedCommons.actions.back} onClick={() => {
              this.props.navigate('/settings/integrations');
            }} />
            <div className={ styles.heading }>
              <Image src={GoogleAnalyticsIcon} />
              <h2 className={styles.name}>{ this.localizedGoogleAnalytics.title }</h2>
              <p className={styles.description}>{ this.localizedGoogleAnalytics.sub_text }</p>
              { this.props.integration &&
                <button className={styles.button}  onClick={this._handleDeactivateClicked}>
                  { this.localizedIntegrations.actions.deactivate }
                </button>
              }
            </div>  
          </Col>
          <Col md={9} className={styles.right}>
            <GoogleAnalyticsActivationPage store={this.context.store} integration = { this.props.integration }/>  
          </Col>
        
        </Row>
        <DeactivateIntegrationContainer 
          name = {this.localizedGoogleAnalytics.title}
          type="google-analytics"
          message={this.localizedGoogleAnalytics.deactivate_slider.sub_text}
          show={this.state.deleteConfirmation}
          onCancel={()=> {
          this.setState({
             deleteConfirmation: false
          })
        }}
       />
      </div>
    );
  }
}

export default GoogleAnalyticsView;